import BaseListPage from "../../../../base/BaseListPage";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import Progress from "../../../../components/Progress";
import Table from "../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../utils/withRouter";
import DefaultState from "./components/DefaultState";
import FilterGenerator from "./components/filterGenerator";
import NoResultState from "./components/NoResultState";
import NegativeRecordsCompanyListPresenter from "./NegativeRecordsCompanyListPresenter";

class NagativeRecordsCompanyListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      selected: [],
      loading: false,
      total: 0,
      count: 0,
      searchedName: "",
      searchLog: {},
      searchStatus: "default",
      searchBtnDisabled: false,
      outSideClient: [],
    };
    this.presenter = new NegativeRecordsCompanyListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase()
    );

    this.fieldsToDisplay = ["company"];
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "records";
  }

  onClickView(index) {
    this.presenter.onClickView(index);
  }

  setSearchedName(name) {
    this.setState({ searchedName: name });
  }

  setSearchStatus(status) {
    this.setState({ searchStatus: status });
  }

  setSearchLog(log) {
    this.setState({ searchLog: log });
  }

  searchSubmit(where, merge) {
    this.setState({ searchBtnDisabled: true });
    this.presenter.searchSubmit(where, merge);
  }

  filterObjects(objects) {
    const uniqueNames = new Set();
    const filterdObjects = objects.filter((item) => {
      const uniqueKey = `${item.firstName}-${item.middleName}-${item.lastName}-${item.alias}`;

      if (!uniqueNames.has(uniqueKey)) {
        uniqueNames.add(uniqueKey);
        return true;
      }
      return false;
    });

    return filterdObjects;
  }

  getActions() {
    return [
      {
        label: "View",
        onClick: this.onClickView.bind(this),
        icon: "bi bi-eye",
      },
    ];
  }

  onClickSaveNoRecord(search) {
    this.presenter.onClickSaveNoRecord(search);
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const user = this.getCurrentUser();
    const { objects, loading, count, searchLog, searchStatus } = this.state;

    return (
      <PageContainer
        title="Negative Records Simple Search"
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <FilterGenerator
          schema={schema}
          onSubmit={this.searchSubmit.bind(this)}
          searchBtnDisabled={this.state.searchBtnDisabled}
        />
        {loading ? (
          <div className="h-100 w-100 d-flex justify-content-center align-items-center">
            <Progress />
          </div>
        ) : objects.length < 1 && searchStatus !== "searched" ? (
          <DefaultState />
        ) : objects.length < 1 ? (
          <NoResultState
            searchLog={searchLog}
            user={user}
            onClickSaveNoRecord={this.onClickSaveNoRecord.bind(this)}
          />
        ) : (
          <Table
            fields={schema.fields}
            objects={this.filterObjects(objects)}
            d
            collapsable
            actions={this.getActions.bind(this)}
            progress={loading}
            excludeFields={Object.keys(schema.fields).filter(
              (key) => !this.fieldsToDisplay.includes(key)
            )}
          />
        )}
      </PageContainer>
    );
  }
}

export default withRouter(NagativeRecordsCompanyListPage);
